"use client";

import { Section } from "./types";

export const arbitrumSections: Section[] = [
  {
    title: "Yield on Pendle pools",
    id: "pendle",
    pools: [
      {
        // pt-rseth-26dec2024-rseth
        address: "0x5ecE952A12b87f909b4Bd8137DD30fd07b80c2C4",
      },
      {
        // pt-wsteth-26jun2025-weth
        address: "0x856e0317130F468d2bcd104b42B82337300765b0",
      },
      {
        // pt-reth-26jun2025-weth
        address: "0xC8C1CdD42D02eaF4F775eaF9f4b4a37a5272118d",
      },
      {
        // pt-weeth-26jun2025-weth
        address: "0xe302CA50234D336A8Cff0AD11Af1Aa00C0F174e2",
      },
      {
        // pt-rseth-26jun2025-weth
        address: "0x727B79bFd88600fa425619280bc24A0B60Cf14DA",
      },
      {
        // pt-unieth-26jun2025-weth
        address: "0x8A048FdC480ADEc0C7A77277F398709AEa7e4461",
      },
      {
        // pt-unieth-26dec2024-unieth
        address: "0x1be9c0343F6A5E3F1E8c76e6cEF05EEbda4074D3",
      },
      {
        // pt-weeth-26dec2024-weeth
        address: "0x2E70CC46F465ab249D6972cCeb0363a6B07AeA01",
      },
    ],
  },
  {
    title: "Yield via points and rewards",
    id: "rewards",
    pools: [
      {
        // knox-eusd
        address: "0x3125e87D2630eb7DADD7F94e2fE05Bd21eE10C4f",
      },
      {
        // ethplus-weth
        address: "0xb1Af7B299ABBE4905Bbc80E614f64caCFEfBc96b",
      },
    ],
  },
];

export const mainnetSections: Section[] = [
  {
    title: "Yield on Pendle pools",
    id: "pendle",
    pools: [
      {
        // pt-rseth-26dec2024-rseth
        address: "0x548F66BC804CB806ae5Ba3FeeE492a49FD8ef173",
      },
      {
        // marginlyPool_pt-lbtc-27mar2025-lbtc
        address: "0xf7710a79F2440423e5865EB3a7DF3e47a430859F",
      },
      {
        // marginlyPool_pt-ebtc-27mar2025-ebtc
        address: "0xd88855292819e34388833A3cb5524eEDf25010AE",
      },
      {
        address: "0x3D6f0097FA10f2e3855377daF2139dBeD66Fb343",
        // "name": "pt-cornlbtc-26dec2024"
      },
      {
        address: "0x056888DD4B31cA090E2FC7ca87AF62B588dD8207",
        // "name": "pt-corn-unibtc-26dec2024"
      },
      {
        address: "0xEe368c5014D218795F76DcDA58e8FD24D04E19Ff",
        // "name": "pt-corn-pumpbtc-26dec2024"
      },
      {
        address: "0xcAbAE9295e274c152b9DcCC124AB06cf78d079Eb",
        // "name": "pt-amphrlrt-26dec2024"
      },
      {
        address: "0xa692B4fb38f8e9aEA229DA05CC2FC9d748218CD3",
        // "name": "pt-pufeth-26dec2024"
      },
      {
        address: "0x530043876F37170468a9F366145E645BEE86da6C",
        // "name": "pt-amphreth-26dec2024"
      },
      {
        address: "0xaE2e6412d5c47e23c55c87e65cb2721Fa799Cb96",
        // "name": "pt-weeths-26dec2024"
      },
      {
        // pt-ageth-26dec2024-ageth
        address: "0xafcC4F047a1012c4b51B69c7C1bB39C5F38F0305",
      },
      {
        // pt-weeth-26dec2024-weth
        address: "0xa77C2275C1F403056c7F73B44df69E374C299dd7",
      },
      {
        // pt-ezeth-26dec2024-ezeth
        address: "0xb34DfB03973e148ED800F369EdE84b92803116CA",
      },
      {
        // pt-amphrlrt-26dec2024-amphrlrt
        address: "0xcAbAE9295e274c152b9DcCC124AB06cf78d079Eb",
      },
      {
        // pt-ebtc-26dec2024-ebtc
        address: "0x2F06faF2A2EEFfBd44a796b8c6d2D04841c6488C",
      },
      {
        // pt-pufeth-26dec2024-pufeth
        address: "0x1F1A9004F00571Ea0Ed79e51bfd2Cdc3954abc40",
      },
      {
        // pt-amphreth-26dec2024-amphreth
        address: "0x530043876F37170468a9F366145E645BEE86da6C",
      },
      {
        // pt-re7lrt-26dec2024-re7lrt
        address: "0x2Df52e18e0fcA1E8CEE272cD034368278a49125f",
      },
      // pt-weeths-26dec2024-weeths
      {
        address: "0xee07F58A274Ebc50f79ccd1d67fF73426a317dAf",
      },
      // marginlyPool_pt-cornlbtc-26dec2024-lbtc
      {
        address: "0x32d850609FDc950bF6E23640d1EB0bbd60a5149c",
      },
    ],
  },
  {
    title: "Yield via points and rewards",
    id: "rewards",
    pools: [
      {
        // unibtc-wbtc
        address: "0x8A171afA8Db2a01E8b280c12db0F5bc2EEEcdc10",
      },
    ],
  },
];

export const blastPools: Section[] = [
  {
    title: "Yield via points and rewards",
    id: "rewards",
    pools: [
      {
        // weth-usdb
        address: "0x12afF531E86f5E9763c6C7D0994AdEfB1a1f844c",
      },
    ],
  },
];
